// extracted by mini-css-extract-plugin
export var messageSideLeft = "_la-1";
export var messageSideRight = "_la-2";
export var orderLookupBubbleContainer = "_la-0";
export var submitButton = "_la-3";